import { Controller } from 'lib_ts/enums/routing/controllers';
import { PlayersRoutes } from 'lib_ts/enums/routing/routes/players';
import { IServerResponse } from 'lib_ts/interfaces/common/i-server-response';
import { IHitterPlayerLink } from 'lib_ts/interfaces/i-player';
import { BaseRESTService } from 'services/_base-rest.service';

export class PlayersService extends BaseRESTService {
  private static instance: PlayersService;
  static getInstance(): PlayersService {
    if (!PlayersService.instance) {
      PlayersService.instance = new PlayersService();
    }

    return PlayersService.instance;
  }

  private constructor() {
    super({
      controller: Controller.Players,
    });
  }

  async getHitterPlayer(
    hitterID: string
  ): Promise<IHitterPlayerLink | undefined> {
    return await this.get({
      uri: `${PlayersRoutes.GetHitterPlayer}/${hitterID}`,
    })
      .then((result: IServerResponse) => {
        if (!result.success || !result.data || result.error) {
          console.error(
            result.error ?? 'encountered an error in getHitterPlayer'
          );
          return undefined;
        }

        return result.data as IHitterPlayerLink;
      })
      .catch((error) => {
        console.error(error ?? 'encountered an error in getHitterPlayer');
        return undefined;
      });
  }
}
